import {Table, Text} from "@mantine/core";
import {IMilestoneAggregation} from "../../../api/Shipment/Shipment.types";

interface Props {
    data: IMilestoneAggregation[],
    onMilestoneClick:(milestone:string)=>void,
}

function ShipmentMilestoneTable ({data, onMilestoneClick}:Props){

    const rows = data.map((curData) => {
        const { milestone, all, caution, critical } = curData;

        return (
            <tr key={milestone}>
                <td><Text variant="link" size="sm" color="blue" sx={()=>({"&:hover":{ cursor:"pointer" }})} onClick={()=>onMilestoneClick(milestone)}>{milestone}</Text></td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{all ? all : 0}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{caution ? caution : 0}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{critical ? critical : 0}</td>
            </tr>
        )
    });

    return (
        <Table striped>
            <thead>
            <tr>
                <th>Milestone</th>
                <th>All</th>
                <th>Caution</th>
                <th>Critical</th>
            </tr>
            </thead>
            <tbody>{rows}</tbody>
        </Table>
    )

}

export default ShipmentMilestoneTable;